<script lang="ts">
/**
 * @deprecated
 */
export default {};
</script>

<script setup lang="ts">
import Tooltip, { type TooltipProps } from "./Tooltip.vue";

defineProps<Omit<TooltipProps, "tooltip">>();
</script>

<template>
	<Tooltip v-bind="$props">
		<template #tooltip>
			<slot />
		</template>
	</Tooltip>
</template>
